import { Helper } from './../shared/helper';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { IFlight } from './flight';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import { environment } from '../../environments/environment';
import { CustomLogger } from '../shared/custom-logger';


@Injectable()
export class FlightService {
  private flightUrl = environment.flightUrl;
  private flightBulkUrl = environment.flightBulkUrl;
  private changeSeatsUrl = environment.changeSeatsUrl;

  constructor(
    private _http: HttpClient,
    private logger: CustomLogger,
    private helper: Helper
  ) {}

  getFlights(params: any, order = ''): Observable<HttpResponse<IFlight[]>> {
    let urlSuf = order;
    if (params.flightDateTimeFrom && params.flightDateTimeTo) {
      urlSuf += `&flightDateTime[after]=${this.helper.formatFilterDate(params.flightDateTimeFrom)}
                &flightDateTime[before]=${this.helper.formatFilterDate(params.flightDateTimeTo)}`;
    } else if (params.flightDateTimeFrom) {
      urlSuf += `&flightDateTime[after]=${this.helper.formatFilterDate(params.flightDateTimeFrom)}`;
    } else if (params.flightDateTimeTo) {
      urlSuf += `&flightDateTime[before]=${this.helper.formatFilterDate(params.flightDateTimeTo)}`;
    }
    delete params.flightDateTimeFrom;
    delete params.flightDateTimeTo;


    if (params.seats_available) {
      urlSuf += `&seatsAvailable[gt]=${params.seats_available}`;
      delete params.seats_available;
    }

    return this._http
      .get<IFlight[]>(this.flightUrl + urlSuf, {
        params: params,
        observe: 'response'
      })
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  getFlight(id: number): Observable<IFlight> {
    if (id === 0) {
      return Observable.of(this.initializeFlight());
    }
    const url = `${this.flightUrl}/${id}`;
    return this._http
      .get<IFlight>(url)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  initializeFlight(): IFlight {
    return {
      id: 0,
      flightNumber: null,
      departure: null,
      destination: null,
      priceFull: null,
      priceChild: null,
      priceInfant: null,
      aircraftName: null,
      seatsTotal: null,
      seatsTaken: null,
      seatsOnlineTotal: null,
      seatsOnlineTaken: null,
      flightDateTime: null,
      updated: null,
      seatsAvailable: null,
      flightDuration: null,
      flightArrival: null,
      flightRegistrationTime: null
    };
  }

  // saveFlight(flight: any): Observable<IFlight> {
  //   if (flight.id === 0) {
  //     return this.createFlights(flight);
  //   }
  //   return this.updateFlight(flight);
  // }

  createFlights(flight: any, repetition: boolean): Observable<IFlight> {
    flight.id = undefined;
    let url;
    repetition ? (url = this.flightBulkUrl) : (url = this.flightUrl);
    return this._http
      .post<IFlight>(url, flight)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  updateFlight(flight: any): Observable<IFlight> {
    const url = `${this.flightUrl}/${flight.id}`;
    return this._http
      .put<IFlight>(url, flight)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  deleteFlight(id): Observable<any> {
    const url = `${this.flightUrl}/${id}`;
    return this._http
      .delete(url)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/flights/flight.service.ts